export const TileConfiguration = Object.freeze([
  {
    title: "2020",
    children: [
      {
        title: "LAS",
        children: [
          {
            id: 23,
            title: "All Data",
          },
          /*
          {
            id: 24,
            title: "Class 12 Overlapping",
          },
          {
            id: 25,
            title: "First Return",
          },
          {
            id: 26,
            title: "Middle Return",
          },
          {
            id: 27,
            title: "Last Returns",
          },
          */
          {
            id: 28,
            title: "Specified Class - Building",
          },
          {
            id: 29,
            title: "Specified Class - Transmission Tower",
          },
          {
            id: 30,
            title: "Specified Class - Ground",
          },
          {
            id: 31,
            title: "Specified Class - Vegetation",
          },
          {
            id: 32,
            title: "Specified Class - Water",
          },
        ],
      },
      {
        title: "ASCII",
        children: [
          {
            id: 33,
            title: "DTM",
          },
          {
            id: 34,
            title: "DSM",
          },
        ],
      },
      {
        title: "dBase IV",
        children: [
          {
            id: 35,
            title: "DTM",
          },
          {
            id: 36,
            title: "DSM",
          },
        ],
      },
      {
        title: "RASTER-Vegetation",
        children: [
          {
            id: 41,
            title: "ERS",
          },
          {
            id: 37,
            title: "GeoTIFF",
          },
          {
            id: 45,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-DTM",
        children: [
          {
            id: 42,
            title: "ERS",
          },
          {
            id: 38,
            title: "GeoTIFF",
          },
          {
            id: 46,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-DSM",
        children: [
          {
            id: 43,
            title: "ERS",
          },
          {
            id: 39,
            title: "GeoTIFF",
          },
          {
            id: 47,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-Intensity Imagery",
        children: [
          {
            id: 44,
            title: "ERS",
          },
          {
            id: 40,
            title: "GeoTIFF",
          },
          {
            id: 48,
            title: "PIX",
          },
        ],
      },
    ],
  },
  {
    title: "2010",
    children: [
      {
        title: "LAS",
        children: [
          {
            id: 1,
            title: "All Data",
          },
          /*
          {
            id: 2,
            title: "Any 1st Returns",
          },
          {
            id: 3,
            title: "1st of Many Returns",
          },
          {
            id: 4,
            title: "Intermediate Returns",
          },
          {
            id: 5,
            title: "Any Last Returns",
          },
          */
          {
            id: 6,
            title: "Ground",
          },
        ],
      },
      {
        title: "ASCII",
        children: [
          {
            id: 7,
            title: "DEM",
          },
          {
            id: 8,
            title: "DSM",
          },
        ],
      },
      {
        title: "dBase IV",
        children: [
          {
            id: 9,
            title: "DEM",
          },
          {
            id: 10,
            title: "DSM",
          },
        ],
      },
      {
        title: "RASTER-Vegetation",
        children: [
          {
            id: 11,
            title: "ERS",
          },
          {
            id: 12,
            title: "GeoTIFF",
          },
          {
            id: 13,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-DTM",
        children: [
          {
            id: 14,
            title: "ERS",
          },
          {
            id: 15,
            title: "GeoTIFF",
          },
          {
            id: 16,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-DSM",
        children: [
          {
            id: 17,
            title: "ERS",
          },
          {
            id: 18,
            title: "GeoTIFF",
          },
          {
            id: 19,
            title: "PIX",
          },
        ],
      },
      {
        title: "RASTER-Intensity Imagery",
        children: [
          {
            id: 20,
            title: "ERS",
          },
          {
            id: 21,
            title: "GeoTIFF",
          },
          {
            id: 22,
            title: "PIX",
          },
        ],
      },
    ],
  },
]);

export const TileLayerUrlBase = `${process.env.VUE_APP_LIDAR_MAP_URL}/ODoLIDAR/MapIndex/MapServer`;

export const TileLayerConfiguration = Object.freeze([
  {
    year: "2020",
    url: `${TileLayerUrlBase}/1`,
    color: [0, 150, 136, 0.75],
  },
  {
    year: "2010",
    url: `${TileLayerUrlBase}/0`,
    color: [25, 118, 210, 0.75],
  },
]);

export const TileYearList = TileConfiguration.map((v) => v.title);
